export default __webpack_public_path__ + "static/media/IMG_4921.5158a0f1.png";